/** Class representing an individual Cortex touch */
export class CortexAppConfig {
  /**
   * Should the script automatically detect touches within the page or wait to be triggered manually?
   * If true, cortexApp.detectTouches() will be called after document.load
   * If false, cortexApp.detectTouches() should be called from a html script tag
   *
   * @type {boolean}
   * @memberof CortexAppConfig
   */
  autoDetectTouches: boolean;

  /**
   * Should the script automatically bind to form submit events?
   *
   * @type {boolean}
   * @memberof CortexAppConfig
   */
  autoBindToFormSubmits: boolean;

  /**
   * Number of minutes after which a new touch will be recorded indicated an idle session refreshing
   *
   * @type {number}
   * @memberof CortexAppConfig
   */
  sessionExpiryInMinutes: number;

  /**
   * Array of querystring variables that the script will detect
   *
   * @type {Array<string>}
   * @default ["utm_source","utm_medium","utm_campaign","utm_term","utm_content","gclid","wbraid","gbraid","fbclid"]
   * @memberof CortexAppConfig
   */
  queryStringToCheck: Array<string>;

  /**
   * This is the id of the input (probably hidden) within a html form to recieve the JSON string of the touch history
   *
   * @type {string}
   * @default ["CortexTouches"]
   * @memberof CortexAppConfig
   */
  fieldNameToPopulate: string;

  /**
   * Should the JSON data passed to the form be a closed JSON array [{touch},{touch}] or a list of JSON objects {touch},{touch},
   * The latter allows for appending to previous values. Default
   *
   * @type {boolean}
   * @default [true]
   * @memberof CortexAppConfig
   */
  formDataAsArray: boolean;

  /**
   * Should the touches history be cleared automatically when populateFormByFormObject or populateFormBySubmitEvent is called.
   * If false, the startNewSession() function should be called as needed.
   *
   * @type {boolean}
   * @default [true]
   * @memberof CortexAppConfig
   */
  clearSessionOnFormSubmit: boolean;

  /**
  * Display console debug messages
  * If true, console.debug messages will be logged at hey moments.
  *
  * @type {boolean}
  * @default [false]
  * @memberof CortexAppConfig
  */
  debugMode: boolean;

  /**
   * Creates an instance of CortexAppConfig.
   * @memberof CortexAppConfig
   */
  constructor() {
    this.autoDetectTouches = false;
    this.autoBindToFormSubmits = false;
    this.sessionExpiryInMinutes = 20;
    this.queryStringToCheck = [
      // utm parameters
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
      // google clicks
      "gclid",
      "wbraid",
      "gbraid",
      // facebook clicks
      "fbclid",
      // microsoft clicks
      "msclkid"
    ];
    this.fieldNameToPopulate = "CortexTouches";
    this.formDataAsArray = true;
    this.clearSessionOnFormSubmit = true;
    this.debugMode = false;
  }
}